module.exports = function() {
  return new Worker(__webpack_public_path__ + "ae46d2eca9435dbcf954.worker.js");
};